/**
 * Country / state options.
 *
 * Every district and locality below is invented. None of them are real
 * Indian places — they exist so the generator can fill an address block
 * with something that reads naturally in the right script without ever
 * printing a real address.
 */

export const COUNTRIES = [
  { code: "IN", name: "India", supported: true },
  { code: "NP", name: "Nepal", supported: false },
  { code: "BD", name: "Bangladesh", supported: false },
  { code: "LK", name: "Sri Lanka", supported: false },
  { code: "AE", name: "United Arab Emirates", supported: false },
  { code: "GB", name: "United Kingdom", supported: false },
  { code: "US", name: "United States", supported: false },
];

const s = (id, name, nameLocal, lang, districts, localities) => ({
  id,
  name,
  nameLocal,
  lang,
  districts,
  localities,
});

export const STATES = [
  s("GJ", "Gujarat", "ગુજરાત", "gu",
    [{ en: "Navsarita", local: "નવસરિતા" }, { en: "Rupgarh", local: "રૂપગઢ" }],
    [{ en: "Shantipura", local: "શાંતિપુરા" }, { en: "Chandanvadi", local: "ચંદનવાડી" }, { en: "Mor Talav", local: "મોરતળાવ" }]),

  s("MH", "Maharashtra", "महाराष्ट्र", "mr",
    [{ en: "Shubhganv", local: "शुभगाव" }, { en: "Ratnadurg", local: "रत्नदुर्ग" }],
    [{ en: "Anandnagar", local: "आनंदनगर" }, { en: "Sahyadri Wadi", local: "सह्याद्री वाडी" }, { en: "Nilkanth Peth", local: "निळकंठ पेठ" }]),

  s("TN", "Tamil Nadu", "தமிழ்நாடு", "ta",
    [{ en: "Ilanjipuram", local: "இளஞ்சிபுரம்" }, { en: "Vetrikudi", local: "வெற்றிக்குடி" }],
    [{ en: "Malargal Nagar", local: "மலர்கள் நகர்" }, { en: "Aruvi Theru", local: "அருவித் தெரு" }, { en: "Kanmani Salai", local: "கண்மணி சாலை" }]),

  s("KL", "Kerala", "കേരളം", "ml",
    [{ en: "Manalpuram", local: "മണൽപുരം" }, { en: "Vanachira", local: "വനച്ചിറ" }],
    [{ en: "Poovanam", local: "പൂവനം" }, { en: "Kadalthira", local: "കടൽത്തീരം" }, { en: "Arayal Mukku", local: "അരയാൽ മുക്ക്" }]),

  s("KA", "Karnataka", "ಕರ್ನಾಟಕ", "kn",
    [{ en: "Hosakere", local: "ಹೊಸಕೆರೆ" }, { en: "Nandivana", local: "ನಂದಿವನ" }],
    [{ en: "Chinnara Badavane", local: "ಚಿನ್ನರ ಬಡಾವಣೆ" }, { en: "Mallige Beedi", local: "ಮಲ್ಲಿಗೆ ಬೀದಿ" }, { en: "Suvarna Nagara", local: "ಸುವರ್ಣ ನಗರ" }]),

  s("TG", "Telangana", "తెలంగాణ", "te",
    [{ en: "Amaravanam", local: "అమరవనం" }, { en: "Cheruvupalle", local: "చెరువుపల్లె" }],
    [{ en: "Sirimalle Nagar", local: "సిరిమల్లె నగర్" }, { en: "Kalyani Veedhi", local: "కల్యాణి వీధి" }, { en: "Vennela Colony", local: "వెన్నెల కాలనీ" }]),

  s("AP", "Andhra Pradesh", "ఆంధ్రప్రదేశ్", "te",
    [{ en: "Suryakonda", local: "సూర్యకొండ" }, { en: "Neelagiri Palem", local: "నీలగిరి పాలెం" }],
    [{ en: "Padmavanam", local: "పద్మవనం" }, { en: "Tulasi Veedhi", local: "తులసి వీధి" }, { en: "Kadambari Colony", local: "కదంబరి కాలనీ" }]),

  s("WB", "West Bengal", "পশ্চিমবঙ্গ", "bn",
    [{ en: "Nabapallipur", local: "নবপল্লীপুর" }, { en: "Shonartari", local: "সোনারতরী" }],
    [{ en: "Palashbon", local: "পলাশবন" }, { en: "Nadighat Para", local: "নদীঘাট পাড়া" }, { en: "Bakul Sarani", local: "বকুল সরণি" }]),

  s("PB", "Punjab", "ਪੰਜਾਬ", "pa",
    [{ en: "Sunehragarh", local: "ਸੁਨਹਿਰਾਗੜ੍ਹ" }, { en: "Phulwara", local: "ਫੁੱਲਵਾੜਾ" }],
    [{ en: "Basant Vihar", local: "ਬਸੰਤ ਵਿਹਾਰ" }, { en: "Nadi Kinara", local: "ਨਦੀ ਕਿਨਾਰਾ" }, { en: "Sarson Mohalla", local: "ਸਰ੍ਹੋਂ ਮੁਹੱਲਾ" }]),

  s("OD", "Odisha", "ଓଡ଼ିଶା", "or",
    [{ en: "Nuapatana", local: "ନୂଆପାଟଣା" }, { en: "Chandanpur Sasan", local: "ଚନ୍ଦନପୁର ଶାସନ" }],
    [{ en: "Kadamba Sahi", local: "କଦମ୍ବ ସାହି" }, { en: "Nadikula", local: "ନଦୀକୂଳ" }, { en: "Suvarnapura", local: "ସୁବର୍ଣ୍ଣପୁର" }]),

  s("AS", "Assam", "অসম", "as",
    [{ en: "Xonalipur", local: "শোণালীপুৰ" }, { en: "Brahmatal", local: "ব্ৰহ্মতল" }],
    [{ en: "Kopou Path", local: "কপৌ পথ" }, { en: "Nodikinar", local: "নদীকিনাৰ" }, { en: "Bogori Gaon", local: "বগৰী গাঁও" }]),

  s("DL", "Delhi", "दिल्ली", "hi",
    [{ en: "Nav Vihar", local: "नव विहार" }, { en: "Purvi Upvan", local: "पूर्वी उपवन" }],
    [{ en: "Kamal Kunj", local: "कमल कुंज" }, { en: "Sarita Marg", local: "सरिता मार्ग" }, { en: "Neem Chowk", local: "नीम चौक" }]),

  s("UP", "Uttar Pradesh", "उत्तर प्रदेश", "hi",
    [{ en: "Gangapuri", local: "गंगापुरी" }, { en: "Sarayganj", local: "सरयूगंज" }],
    [{ en: "Tulsi Nagar", local: "तुलसी नगर" }, { en: "Amrai Mohalla", local: "अमराई मोहल्ला" }, { en: "Baans Bazaar", local: "बाँस बाज़ार" }]),

  s("RJ", "Rajasthan", "राजस्थान", "hi",
    [{ en: "Balukagarh", local: "बालूकागढ़" }, { en: "Morchand", local: "मोरचंद" }],
    [{ en: "Rangili Gali", local: "रंगीली गली" }, { en: "Kesar Haveli", local: "केसर हवेली" }, { en: "Retmali Basti", local: "रेतमाली बस्ती" }]),

  s("MP", "Madhya Pradesh", "मध्य प्रदेश", "hi",
    [{ en: "Vindhyaganv", local: "विंध्यगाँव" }, { en: "Narmadpur", local: "नर्मदपुर" }],
    [{ en: "Peepal Chowk", local: "पीपल चौक" }, { en: "Sagwan Vihar", local: "सागवान विहार" }, { en: "Mahua Tola", local: "महुआ टोला" }]),

  s("BR", "Bihar", "बिहार", "hi",
    [{ en: "Makhanpur", local: "मखानपुर" }, { en: "Kosidham", local: "कोसीधाम" }],
    [{ en: "Litti Bazaar", local: "लिट्टी बाज़ार" }, { en: "Ganga Tat", local: "गंगा तट" }, { en: "Bel Gali", local: "बेल गली" }]),

  s("HR", "Haryana", "हरियाणा", "hi",
    [{ en: "Bajragarh", local: "बजरागढ़" }, { en: "Sarsonpur", local: "सरसोंपुर" }],
    [{ en: "Chaupal Marg", local: "चौपाल मार्ग" }, { en: "Neem Sarai", local: "नीम सराय" }, { en: "Harit Vihar", local: "हरित विहार" }]),

  s("AR", "Arunachal Pradesh", "अरुणाचल प्रदेश", "hi",
    [{ en: "Siyomghat", local: "सियोमघाट" }, { en: "Tawangpur", local: "तवांगपुर" }],
    [{ en: "Orchid Vihar", local: "ऑर्किड विहार" }, { en: "Nadi Tal", local: "नदी ताल" }, { en: "Pine Basti", local: "पाइन बस्ती" }]),

  s("CG", "Chhattisgarh", "छत्तीसगढ़", "hi",
    [{ en: "Sarguja Van", local: "सरगुजा वन" }, { en: "Mahanadipur", local: "महानदीपुर" }],
    [{ en: "Sal Chowk", local: "साल चौक" }, { en: "Dhaan Basti", local: "धान बस्ती" }, { en: "Kosa Nagar", local: "कोसा नगर" }]),

  s("GA", "Goa", "गोंय", "kok",
    [{ en: "Sonvaddo", local: "सोनवाडो" }, { en: "Xirodwadi", local: "शिरोडवाडी" }],
    [{ en: "Palm Vaddo", local: "पाम वाडो" }, { en: "Nadi Kinaro", local: "नदी किनारो" }, { en: "Vhodli Bhat", local: "व्होडली भाट" }]),

  s("HP", "Himachal Pradesh", "हिमाचल प्रदेश", "hi",
    [{ en: "Devdarpur", local: "देवदारपुर" }, { en: "Himvanganv", local: "हिमवनगाँव" }],
    [{ en: "Seb Bagicha", local: "सेब बगीचा" }, { en: "Chir Marg", local: "चीड़ मार्ग" }, { en: "Dhar Basti", local: "धार बस्ती" }]),

  s("JH", "Jharkhand", "झारखंड", "hi",
    [{ en: "Sal Vanpur", local: "साल वनपुर" }, { en: "Damodarganj", local: "दामोदरगंज" }],
    [{ en: "Palash Tola", local: "पलाश टोला" }, { en: "Khanij Nagar", local: "खनिज नगर" }, { en: "Bans Chowk", local: "बाँस चौक" }]),

  s("MN", "Manipur", "মণিপুর", "bn",
    [{ en: "Loktakpur", local: "লোকতাকপুর" }, { en: "Kangleigaon", local: "কাংলেইগাঁও" }],
    [{ en: "Kombirei Leikai", local: "কোম্বিরেই লেইকাই" }, { en: "Nadi Para", local: "নদী পাড়া" }, { en: "Tamphapat", local: "তম্ফাপাত" }]),

  s("ML", "Meghalaya", "मेघालय", "hi",
    [{ en: "Meghganv", local: "मेघगाँव" }, { en: "Jharnapur", local: "झरनापुर" }],
    [{ en: "Badal Basti", local: "बादल बस्ती" }, { en: "Pahar Tola", local: "पहाड़ टोला" }, { en: "Jhula Path", local: "झूला पथ" }]),

  s("MZ", "Mizoram", "मिज़ोरम", "hi",
    [{ en: "Pahargaon", local: "पहाड़गाँव" }, { en: "Bansvanpur", local: "बाँसवनपुर" }],
    [{ en: "Neel Tila", local: "नील टीला" }, { en: "Bansvan", local: "बाँसवन" }, { en: "Megh Basti", local: "मेघ बस्ती" }]),

  s("NL", "Nagaland", "नागालैंड", "hi",
    [{ en: "Hornbilpur", local: "हॉर्नबिलपुर" }, { en: "Shailganv", local: "शैलगाँव" }],
    [{ en: "Kohra Tola", local: "कोहरा टोला" }, { en: "Van Path", local: "वन पथ" }, { en: "Sopan Basti", local: "सोपान बस्ती" }]),

  s("SK", "Sikkim", "सिक्किम", "ne",
    [{ en: "Himalpur", local: "हिमालपुर" }, { en: "Tistaganv", local: "तिस्तागाँव" }],
    [{ en: "Sunakhari Marg", local: "सुनाखरी मार्ग" }, { en: "Chiya Bagan", local: "चिया बगान" }, { en: "Hiundhara", local: "हिउँधारा" }]),

  s("TR", "Tripura", "ত্রিপুরা", "bn",
    [{ en: "Bansbari", local: "বাঁশবাড়ি" }, { en: "Gomotipur", local: "গোমতীপুর" }],
    [{ en: "Ananas Para", local: "আনারস পাড়া" }, { en: "Rabar Bagan", local: "রাবার বাগান" }, { en: "Pahar Tola", local: "পাহাড় টোলা" }]),

  s("UK", "Uttarakhand", "उत्तराखंड", "hi",
    [{ en: "Devbhoomipur", local: "देवभूमिपुर" }, { en: "Gangotripath", local: "गंगोत्रीपथ" }],
    [{ en: "Buransh Vihar", local: "बुरांश विहार" }, { en: "Devdar Marg", local: "देवदार मार्ग" }, { en: "Ghat Basti", local: "घाट बस्ती" }]),

  s("AN", "Andaman & Nicobar Islands", "अंडमान और निकोबार द्वीपसमूह", "hi",
    [{ en: "Samudrapur", local: "समुद्रपुर" }, { en: "Pravalganj", local: "प्रवालगंज" }],
    [{ en: "Shankh Tola", local: "शंख टोला" }, { en: "Nariyal Marg", local: "नारियल मार्ग" }, { en: "Lehar Basti", local: "लहर बस्ती" }]),

  s("CH", "Chandigarh", "ਚੰਡੀਗੜ੍ਹ", "pa",
    [{ en: "Gulabgarh", local: "ਗੁਲਾਬਗੜ੍ਹ" }, { en: "Sukhnavadi", local: "ਸੁਖਨਾਵਾੜੀ" }],
    [{ en: "Sector Bagh", local: "ਸੈਕਟਰ ਬਾਗ਼" }, { en: "Rock Vihar", local: "ਰੌਕ ਵਿਹਾਰ" }, { en: "Chinar Marg", local: "ਚਿਨਾਰ ਮਾਰਗ" }]),

  s("DH", "Dadra & Nagar Haveli and Daman & Diu", "દાદરા અને નગર હવેલી અને દમણ અને દીવ", "gu",
    [{ en: "Sagarvadi", local: "સાગરવાડી" }, { en: "Vantoli", local: "વનટોળી" }],
    [{ en: "Naral Vadi", local: "નારળવાડી" }, { en: "Dariya Marg", local: "દરિયા માર્ગ" }, { en: "Amba Falia", local: "આંબા ફળિયા" }]),

  s("JK", "Jammu & Kashmir", "जम्मू और कश्मीर", "hi",
    [{ en: "Chinarpur", local: "चिनारपुर" }, { en: "Dalganv", local: "डलगाँव" }],
    [{ en: "Kesar Bagh", local: "केसर बाग़" }, { en: "Shikara Ghat", local: "शिकारा घाट" }, { en: "Akhrot Basti", local: "अखरोट बस्ती" }]),

  s("LA", "Ladakh", "लद्दाख", "hi",
    [{ en: "Himshikharpur", local: "हिमशिखरपुर" }, { en: "Sindhughat", local: "सिंधुघाट" }],
    [{ en: "Khubani Marg", local: "खुबानी मार्ग" }, { en: "Gompa Tola", local: "गोम्पा टोला" }, { en: "Nubra Basti", local: "नुब्रा बस्ती" }]),

  s("LD", "Lakshadweep", "ലക്ഷദ്വീപ്", "ml",
    [{ en: "Pavizhathuruth", local: "പവിഴത്തുരുത്ത്" }, { en: "Kadalpuram", local: "കടൽപുരം" }],
    [{ en: "Thenga Thottam", local: "തെങ്ങ് തോട്ടം" }, { en: "Alakkara", local: "അലക്കര" }, { en: "Muthu Theruv", local: "മുത്ത് തെരുവ്" }]),

  s("PY", "Puducherry", "புதுச்சேரி", "ta",
    [{ en: "Kadalmedu", local: "கடல்மேடு" }, { en: "Poovarasampet", local: "பூவரசம்பேட்டை" }],
    [{ en: "Vellai Theru", local: "வெள்ளைத் தெரு" }, { en: "Alai Salai", local: "அலைச் சாலை" }, { en: "Mullai Nagar", local: "முல்லை நகர்" }]),
].sort((a, b) => a.name.localeCompare(b.name));

export const getState = (id) => STATES.find((st) => st.id === id) || STATES[0];
